import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class AppStatusService {
  get online(): boolean {
    const localStorageDprApp = JSON.parse(
      window.localStorage.getItem('dpr_app')
    );
    return window.navigator.onLine && !localStorageDprApp?.isAppLockedInOffline;
  }
}
